/** Recharts stroke/fill helpers; reads current document theme (matches previous inline usage). */
export function getRechartsTheme() {
  const dark = typeof document !== 'undefined' && document.documentElement.classList.contains('dark');
  return {
    gridStroke: dark ? '#374151' : '#e5e7eb',
    axisStroke: dark ? '#9ca3af' : '#6b7280',
    legendColor: dark ? '#f3f4f6' : '#111827',
  };
}
